import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ConfigPages, ConfigProblem } from './ConfigurationParts';
import { listPurposes, type NoteType, type PurposePage } from './api';
export function LinkedPurposes({ type }: { readonly type: NoteType['noteType'] }) {
  const { t } = useTranslation('expenses');
  const [data, setData] = useState<PurposePage | null>(null);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let live = true;
    setError('');
    setData(null);
    void listPurposes({ noteType: type, page, pageSize: 50 }).then((outcome) => {
      if (!live) return;
      if (outcome.ok) setData(outcome.value);
      else setError(outcome.code);
    });
    return () => {
      live = false;
    };
  }, [type, page, retry]);
  let content = <p role="status">{t('configuration.loading')}</p>;
  if (error) content = <ConfigProblem code={error} retry={() => setRetry((n) => n + 1)} />;
  else if (data)
    content = (
      <>
        {data.items.length === 0 ? (
          <p>{t('configuration.noLinked')}</p>
        ) : (
          <ul className="grid gap-2 sm:grid-cols-2">
            {data.items.map((p) => (
              <li key={p.id}>
                <Link
                  to={`/expenses/settings/purposes?view=all&purpose=${p.id}`}
                  className="text-link inline-flex min-h-11 items-center gap-2 underline-offset-4 hover:underline"
                >
                  {p.code} · {p.label}
                  {p.active ? null : (
                    <span className="bg-muted text-muted-foreground rounded-md px-1.5 py-0.5 text-xs">
                      {t('configuration.archived')}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        )}
        {data.total > 50 ? (
          <ConfigPages page={page} pageSize={50} total={data.total} onPage={setPage} />
        ) : null}
      </>
    );
  return (
    <section className="space-y-3">
      <h2 className="font-semibold">{t('configuration.linkedPurposes')}</h2>
      {content}
    </section>
  );
}
